import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { margin, padding } from "polished";
import React from "react";

import { ResponsiveIcon } from "@brexhq/next/src/components/shared/Icon";
import { Link } from "@brexhq/next/src/components/shared/Link";

export const NavBarPartnerLogoWrapper = styled.div(({ color }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  transition: "all .25s ease-out",
  color: color,
}));

export const NavBarLogoBorder = styled.div(({ theme }) => ({
  borderRight: `1px solid ${theme.colors.border.default}`,
  ...padding(0, theme.spacing.m16, 0, 0),
  ...margin(0, theme.spacing.m16, 0, 0),
}));

export const PartnerLogo = styled.img({
  objectFit: "contain",
  maxHeight: 27,
  objectPosition: "left",
  width: "auto",
});

export const LinkedLogo: React.FC<{
  isFooter?: boolean;
  logoColor?: string;
  partnerLogo?: string;
  rawPartnerLogoUrl?: string; //Image urls not from sanity
  preventLogoLink?: boolean;
}> = ({
  isFooter = false,
  logoColor,
  partnerLogo,
  rawPartnerLogoUrl,
  preventLogoLink,
}) => {
  const { spacing, colors } = useTheme();
  const color = logoColor
    ? logoColor
    : isFooter
    ? colors.content.inverse.primary
    : colors.content.primary;

  const partnerLogoImgUrl = rawPartnerLogoUrl ?? partnerLogo;

  const Logo = () => (
    <NavBarPartnerLogoWrapper color={color}>
      {partnerLogoImgUrl ? (
        <>
          <NavBarLogoBorder>
            <BrexLogo />
          </NavBarLogoBorder>
          <PartnerLogo src={partnerLogoImgUrl} />
        </>
      ) : (
        <BrexLogo />
      )}
    </NavBarPartnerLogoWrapper>
  );

  if (preventLogoLink) return <Logo />;

  return (
    <Link
      modifier="unstyled"
      component={isFooter ? "footer" : "nav"}
      section="logo"
      to="/"
      label="Brex logo"
      aria-label="Brex logo"
      margin={[0, 0, isFooter ? spacing.m48 : 0, 0]}
    >
      <Logo />
    </Link>
  );
};

// const BrexPrideLogo = ({ color }: { color: string }) => {
//   const isWhite = color === "#FFFFFF" || color === "white";
//   return (
//     <ResponsiveColoredIcon
//       icon={isWhite ? "BrexPrideLogoWhite" : "BrexPrideLogoBlack"}
//       responsive={{
//         LRG: { width: 122, height: 32 },
//         MED: { width: 92, height: 24 },
//         SML: { width: 92, height: 24 },
//       }}
//     />
//   );
// };

const BrexLogo: React.FC = () => (
  <ResponsiveIcon
    icon="RebirthLogo"
    responsive={{
      LRG: { width: 78, height: 20 },
      MED: { width: 78, height: 20 },
      SML: { width: 92, height: 24 },
    }}
  />
);
